import { render, staticRenderFns } from "./AppBrandMark.vue?vue&type=template&id=6d0a9b4a&scoped=true&"
import script from "./AppBrandMark.vue?vue&type=script&lang=js&"
export * from "./AppBrandMark.vue?vue&type=script&lang=js&"
import style0 from "./AppBrandMark.vue?vue&type=style&index=0&id=6d0a9b4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0a9b4a",
  null
  
)

export default component.exports